import React, { useState } from "react";
import * as XLSX from "xlsx";
import { toast, ToastContainer } from 'react-toastify';
import Axios from "axios";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import ConfigFileGenerator from "./GenerateConfigFile";
import ConfigFile from "./ParsePanelData";
import ExcelJS from "exceljs";
import { Snackbar, Alert, CircularProgress, Backdrop } from "@mui/material";
import veloxLogo from "../Assets/icons/newLogo.png";
const CloudProContentButton = ({ selectedProject, panelVersion, updatePanels }) => {

  const fileInputRef = useRef(null);
  const { mdId } = useParams();
  const siId = localStorage.getItem("siId");
  const [configFileData, setConfigFileData] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("success");


  // ─── Export .cfg file ────────────────────────────────────────────────────────
 const handleExport = () => {
  if (!selectedProject) {
    alert("Unknown issue, please refresh the page first!");
    return;
  }

  const panelVersion = sessionStorage.getItem("panelVersion1");

  try {
    
const raw = selectedProject?.panel?.VT5000_CONFIG || {};
console.log("RAW KEYS:", Object.keys(raw));
console.log("OutputZone:", raw.OutputZone?.length);
console.log("Zone_Table:", raw.Zone_Table?.length);
console.log("panel keys:", Object.keys(selectedProject?.panel || {}));
    const daylightSave = raw.DaylightSaving || raw.Daylightsaving || {};
console.log("---------"+panelVersion)
    const sourceDep = raw.dependency || [];
    const normalizedDependency = [];
    for (let i = 0; i < 105; i++) {
      normalizedDependency[i] = {
        dependencyType: 0,
        information_field1: 0, information_field2: 0, information_field3: 0,
        information_field4: 0, information_field5: 0, information_field6: 0,
        information_field7: 0, information_field8: 0, information_field9: 0,
        information_field10: 0, information_field11: 0, information_field12: 0,
        information_field13: 0, information_field14: 0, information_field15: 0,
        information_field16: 0, information_field17: 0, information_field18: 0,
        information_field19: 0,
        ...(sourceDep[i] || {}),
      };
    }

    const config = {
  OutputZones:       (raw.outputzones    || []).slice(0, 256),
  ZoneTable:         (raw.zonetable      || []).slice(0, 192),
  GeneralParameters: raw.generalparameters || {},
  Codes:             raw.codes           || { engineer: 0, op1: 0, op2: 0, op3: 0 },
  DaylightSaving: {
    savingTime: {
      startDay:   raw.daylightsaving?.savingTime?.startDay   ?? 0,
      startMonth: raw.daylightsaving?.savingTime?.startMonth ?? 0,
      endDay:     raw.daylightsaving?.savingTime?.endDay     ?? 0,
      endMonth:   raw.daylightsaving?.savingTime?.endMonth   ?? 0,
    },
    mode:          raw.daylightsaving?.mode          ?? 0,
    notProgrammed: raw.daylightsaving?.notProgrammed ?? 0,
  },
  Holidays:      (raw.holidays      || []).slice(0, 12),
  TimeIntervals: (raw.timeintervals || []).slice(0, 255),
  WeeklyTrends:  (raw.weeklytrends  || []).slice(0, 255),
  FlogicPr:      (raw.flogicpr      || []).slice(0, 192),
  // ArgusTablePr:  (raw.argustablepr  || []).slice(0, 9),
   ArgusTablePr: (
  raw.ArgusTablePr ||
  raw.argustablepr ||
  []
).slice(0, 9),
  VTNet:         (raw.vtnets        || []).slice(0, 64),
  Dependency:    normalizedDependency,
};

    if (!config.ArgusTablePr.length) {
      alert("No devices found. Please upload the Excel template first.");
      return;
    }

    console.log("FINAL EXPORT CONFIG:", config);
    console.log("OutputZones length:", config.OutputZones.length);
    console.log("ZoneTable length:", config.ZoneTable.length);
const LOOP_NUMBER_MAX = 9;     
const MAX_ARGUS_DEVICES = 240; 

const makeEmptyArgusDevice = () => ({
  deviceType: 0, sounderBase: 0, name: "",
  alarmVerification: 0, alarmVerificationDelay: 0, isGas: 0, isSounder: 0,
  lastTipo: 0, isMultiSensor: 0, isCallPoint: 0, isRadio: 0, isFlasher: 0,
  preAllTemp: 0, isRepeater: 0, prealarm: 0, dayNight: 0, sensSecDis: 0,
  technical: 0, detectorDaySensitivity: 0, detectorNightSensitivity: 0,
  resSensor: 0, evacuationEnabled: 0, programmed: 0, pNP: 0, secDisEn: 0,
  intendedDisChannel: 0, zone: 0, zone2: 0, zone3: 0, zone4: 0,
  technicalFault: 0, technicalRestore: 0,
  detectorMultiSenseWeekCalendar: 0, detectorSensitivityWeekCalendar: 0,
  tone: 0, volume: 0,
});

const paddedArgusTablePr = [];
for (let i = 0; i < LOOP_NUMBER_MAX; i++) {
  const existingLoop = config.ArgusTablePr[i] || [];
  const loop = [];
  for (let j = 0; j < MAX_ARGUS_DEVICES; j++) {
    loop.push(existingLoop[j] || makeEmptyArgusDevice());
  }
  paddedArgusTablePr.push(loop);
}
config.ArgusTablePr = paddedArgusTablePr;
    //  pass remapped config, NOT raw VT5000_CONFIG
    const generator = new ConfigFileGenerator(config, panelVersion);
    const generatedBuffer = generator.generateConfigFile();

    console.log("Generated buffer size:", generatedBuffer.length);
console.log(
  "EXPORT DEVICE",
  config.ArgusTablePr?.[0]?.[0]
)
    const blob = new Blob([generatedBuffer], { type: "application/octet-stream" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "VELOXCONFIG.CFG";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  } catch (err) {
    console.error("FULL EXPORT ERROR:", err);
    alert("Export failed: " + err.message);
  }
};
  // ─── Upload Excel ────────────────────────────────────────────────────────────
const handleExcelUpload = (event) => {
    const panelContentId =
    selectedProject.panel?.panelContent_id ||
    selectedProject.panelContent_id ||
    sessionStorage.getItem("panelContentId");
    if (!panelContentId) {
    setOpenSnackbar(true);
          setAlertMsg("No panel selected. Please select the panel.");
          setAlertType("error");
    return;
  }

  const file = event.target.files[0];
  if (!file) return;

  const config = selectedProject?.panel?.VT5000_CONFIG || {};

  let argusTablePr =
    config.ArgusTablePr || config.argustablepr || [];

  const zoneTable =
    config.ZoneTable || config.zonetable || [];



  if (!panelContentId) {
     setOpenSnackbar(true);
   setAlertMsg("Panel content ID missing. Please reopen the panel.");
     setAlertType("error");
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: "array", codepage: 65001 });

    const loopSheetNames = workbook.SheetNames.filter((name) => /^Loop\d+$/i.test(name));

    const zonesSet = new Set();
    const isF7 = sessionStorage.getItem("panelVersion1");

    const makeEmptyDevice = () => ({
      lastTipo: 0,
      isMultiSensor: 0,
      deviceType: 0,
      isCallPoint: 0,
      isGas: 0,
      isFlasher: 0,
      isSounder: 0,
      isRepeater: 0,
      programmed: 0,
      name: "",
      zone: 0,
      zone2: 0,
      zone3: 0,
      zone4: 0,
    });

    const NUM_DEVICES_PER_LOOP = 240; 
argusTablePr = loopSheetNames.map(() =>
  Array.from({ length: NUM_DEVICES_PER_LOOP }, () => makeEmptyDevice())
);

    for (let i = 0; i < loopSheetNames.length; i++) {
      const sheetName = loopSheetNames[i];
      const worksheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      for (let j = 3; j < jsonData.length; j++) {
        const row = jsonData[j];
        if (!row || row.length === 0) continue;

        const type = (row[1] || "").toString().toLowerCase().trim();
        const deviceName = (row[2] || "").toString().trim();

        const zone = Number(row[4]) || 0;
        const zone2 = isF7 ? (Number(row[5]) || 0) : 0;
        const zone3 = isF7 ? (Number(row[6]) || 0) : 0;
        const zone4 = isF7 ? (Number(row[7]) || 0) : 0;

        [zone, zone2, zone3, zone4].forEach((z) => {
          if (z > 0) zonesSet.add(z);
        });

        if (!argusTablePr[i]) argusTablePr[i] = [];
        if (!argusTablePr[i][j - 3]) argusTablePr[i][j - 3] = makeEmptyDevice();

        const device = argusTablePr[i][j - 3];

        device.lastTipo = 0;
        device.isMultiSensor = 0;
        device.deviceType = 0;
        device.isCallPoint = 0;
        device.isGas = 0;
        device.isFlasher = 0;
        device.isSounder = 0;
        device.isRepeater = 0;
        device.programmed = 0;

        switch (type) {
          case "smoke":
            device.programmed = 1;
            break;
          case "thermal":
            device.lastTipo = 1;
            device.programmed = 1;
            break;
          case "smoke therm.":
            device.isMultiSensor = 1;
            device.programmed = 1;
            break;
          case "call point":
            device.lastTipo = 3;
            device.deviceType = 1;
            device.isCallPoint = 1;
            device.programmed = 1;
            break;
          case "gas":
            device.lastTipo = 3;
            device.deviceType = 1;
            device.isGas = 1;
            device.programmed = 1;
            break;
          case "input":
            device.lastTipo = 3;
            device.deviceType = 1;
            device.programmed = 1;
            break;
          case "flasher":
            device.lastTipo = 4;
            device.deviceType = 1;
            device.isFlasher = 1;
            device.programmed = 1;
            break;
          case "siren":
            device.lastTipo = 4;
            device.deviceType = 1;
            device.isSounder = 1;
            device.programmed = 1;
            break;
          case "rep.led":
            device.lastTipo = 4;
            device.deviceType = 1;
            device.isRepeater = 1;
            device.programmed = 1;
            break;
          case "output":
            device.lastTipo = 4;
            device.deviceType = 1;
            device.programmed = 1;
            break;
          case "xpander":
            device.lastTipo = 5;
            device.deviceType = 1;
            device.programmed = 1;
            break;
          default:
            device.programmed = 0;
        }

        if (deviceName !== "") device.name = deviceName;

        device.zone = zone;
        device.zone2 = zone2;
        device.zone3 = zone3;
        device.zone4 = zone4;
      }
    }

    
    zoneTable.forEach((zoneObj) => {
      if (zoneObj) zoneObj.programmed = 0;
    });

    zonesSet.forEach((z) => {
      const zoneObj = zoneTable?.[z - 1];
      if (zoneObj) zoneObj.programmed = 1;
    });

   

    Axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/update_panel_devices`,
      {
        projectId: selectedProject.project_id,
        panelContentId,
        argusTablePr: argusTablePr,
      }
    )
      .then((response) => {
        if (response.data.success) {
          setOpenSnackbar(true);
          setAlertMsg("Excel uploaded successfully!");
          setAlertType("success");
        } else {
          setOpenSnackbar(true);
          setAlertMsg(response.data.msg || response.data.message || "Failed to update Excel template");
          setAlertType("error");
        }
      })
      .catch((error) => {
        setOpenSnackbar(true);
        setAlertMsg("Error updating Excel template");
        setAlertType("error");
      });
  };

  reader.readAsArrayBuffer(file);
};
  const handleExcelExport = async () => {
    if (!selectedProject || !selectedProject.panel) {
      console.warn("No project selected or panel not loaded. Export skipped.");
      return;
    }

    const rawConfig = selectedProject.panel?.VT5000_CONFIG || {};

    const config = {
      ArgusTablePr:
        rawConfig.ArgusTablePr || rawConfig.argustablepr || [],
      GeneralParameters:
        rawConfig.GeneralParameters || rawConfig.generalparameters || {},
      OutputZones:
        rawConfig.OutputZones || rawConfig.outputzones || [],
      Dependency:
        rawConfig.Dependency || rawConfig.dependency || [],
      VTNet:
        rawConfig.VTNet || rawConfig.vtnets || [],
    };

    const generalParams = config.GeneralParameters;

    const loopCardNb = generalParams.loopCardNb || 0;
    const numLoops = 1 + 2 * loopCardNb;
    const numDevices = 240;

    const isF7= sessionStorage.getItem("panelVersion1");

    const panelName = (
      generalParams.panelName ||
      selectedProject.name ||
      "Unnamed"
    ).replace(/\u0000/g, "");

    const workbook = new ExcelJS.Workbook();

    // ─── Logo ─────────────────────────────────────────────
    let imageId = null;

    try {
      const response = await fetch(veloxLogo);

      if (!response.ok) {
        throw new Error("Image not found");
      }

      const imageBuffer = await response.arrayBuffer();

      imageId = workbook.addImage({
        buffer: imageBuffer,
        extension: "png",
      });
    } catch (err) {
      console.warn("Logo load failed:", err.message);
    }



    for (let loop = 1; loop <= numLoops; loop++) {
      const worksheet = workbook.addWorksheet(`Loop${loop}`);

      // ─── Header ─────────────────────────────────────────

      if (imageId !== null) {
        worksheet.getRow(1).height = 40;

        worksheet.addImage(imageId, {
          tl: { col: 0, row: 0 },
          br: { col: 1, row: 1 },
          editAs: "oneCell",
        });
      }

      worksheet.getCell("B1").value = `Panel name: ${panelName}`;

      worksheet.getCell("B1").font = {
        bold: true,
        size: 14,
      };
      worksheet.getCell("B1").alignment = {
  wrapText: true,
  vertical: "middle",
};
    

const lastCol = isF7 ? "H" : "E";
worksheet.mergeCells(`B2:${lastCol}2`);

const instructionCell = worksheet.getCell("B2");
instructionCell.value =
  "Please edit or copy paste cells only from cell B4 to B243 and from cell C4 to F243.";

instructionCell.font = {
  italic: true,
  size: 10,
  color: { argb: "FFFF0000" },
};

instructionCell.alignment = {
  wrapText: true,
  vertical: "middle",
};

worksheet.getRow(2).height = 20;
      // ─── Column Headers ────────────────────────────────

      const headerRow = [
        "Device #",
        "Device Type",
        "Description (Max 20 Characters. Any additional characters will be deleted)",
        "Node #",
        "Zone",
        ...(isF7 ? ["Zone 2", "Zone 3", "Zone 4"] : []),
      ];

      const header = worksheet.addRow(headerRow);

      header.font = { bold: true };

      header.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD9E1F2" },
        };

        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };

        cell.alignment = {
          wrapText: true,
          vertical: "middle",
        };
      });

      // ─── Widths ────────────────────────────────────────

      worksheet.getColumn(1).width = 22;
      worksheet.getColumn(2).width = 18;
      worksheet.getColumn(3).width = 50;
      worksheet.getColumn(4).width = 10;
      worksheet.getColumn(5).width = 10;

      if (isF7) {
        worksheet.getColumn(6).width = 10;
        worksheet.getColumn(7).width = 10;
        worksheet.getColumn(8).width = 10;
      }

      // ─── Device Rows ───────────────────────────────────

      const devices = config.ArgusTablePr?.[loop - 1] || [];

      for (let i = 1; i <= numDevices; i++) {
        const device = devices[i - 1];

        let deviceType = "";

        if (device?.programmed === 1) {
          const isModule = device.deviceType === 1;
          const isDevice = device.deviceType === 0;

          const isSmoke =
            isDevice &&
            device.lastTipo === 0 &&
            device.isMultiSensor === 0;

          const isThermal =
            isDevice &&
            device.lastTipo === 1;

          const isSmokeTherm =
            isDevice &&
            device.lastTipo === 0 &&
            device.isMultiSensor === 1;

          const isCallPoint =
            isModule &&
            device.lastTipo === 3 &&
            device.isCallPoint === 1;

          const isGas =
            isModule &&
            device.lastTipo === 3 &&
            device.isGas === 1;

          const isInput =
            isModule &&
            device.lastTipo === 3 &&
            !isCallPoint &&
            !isGas;

          const isFlasher =
            isModule &&
            device.lastTipo === 4 &&
            device.isFlasher === 1;

          const isSiren =
            isModule &&
            device.lastTipo === 4 &&
            device.isSounder === 1;

          const isRepeater =
            isModule &&
            device.lastTipo === 4 &&
            device.isRepeater === 1;

          const isOutput =
            isModule &&
            device.lastTipo === 4 &&
            !isFlasher &&
            !isSiren &&
            !isRepeater;

          const isExpander =
            isModule &&
            device.lastTipo === 5;

          if (isSmoke) deviceType = "Smoke";
          else if (isThermal) deviceType = "Thermal";
          else if (isSmokeTherm) deviceType = "Smoke Therm.";
          else if (isCallPoint) deviceType = "Call point";
          else if (isGas) deviceType = "Gas";
          else if (isInput) deviceType = "Input";
          else if (isFlasher) deviceType = "Flasher";
          else if (isSiren) deviceType = "Siren";
          else if (isRepeater) deviceType = "Rep.Led";
          else if (isOutput) deviceType = "Output";
          else if (isExpander) deviceType = "XPander";
        }

        const rowValues = [
          `Loop ${loop} Device ${i}`,
          deviceType,

          device?.name
            ? device.name
              .replace(/[\x00-\x1F\x7F]/g, "")
              .trim()
            : "",

          generalParams?.vtnetPanelAddress > 0
            ? generalParams.vtnetPanelAddress
            : "",

          device?.zone > 0 ? device.zone : "",

          ...(isF7
            ? [
              device?.zone2 > 0 ? device.zone2 : "",
              device?.zone3 > 0 ? device.zone3 : "",
              device?.zone4 > 0 ? device.zone4 : "",
            ]
            : []),
        ];

        const dataRow = worksheet.addRow(rowValues);

        if (i % 2 === 0) {
          dataRow.eachCell((cell) => {
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFF2F2F2" },
            };
          });
        }

        if (device?.programmed === 1) {
          dataRow.getCell(2).font = {
            bold: true,
          };
        }
      }

      worksheet.views = [
        {
          state: "frozen",
          ySplit: 2,
        },
      ];
    }



    const outputSheet = workbook.addWorksheet("OutputZones");

    const outputHeader = outputSheet.addRow([
      "Output Zone",
      "Programmed",
      "Device Slot",
      "Loop",
      "Address",
      "Active",
    ]);

    outputHeader.font = { bold: true };

    const outputZones = config.OutputZones || [];

    outputZones.forEach((oz, ozIndex) => {
      (oz.devices || []).forEach((device, slotIndex) => {
        outputSheet.addRow([
          ozIndex + 1,
          oz.programmed || 0,
          slotIndex + 1,
          device.loop || 0,
          device.address || 0,
          device.active || 0,
        ]);
      });
    });


    const dependencySheet =
      workbook.addWorksheet("Dependency");

    const depHeaders = [
      "Index",
      "dependencyType",
    ];

    for (let i = 1; i <= 19; i++) {
      depHeaders.push(`information_field${i}`);
    }

    const depHeaderRow =
      dependencySheet.addRow(depHeaders);

    depHeaderRow.font = { bold: true };

    (config.Dependency || []).forEach((dep, index) => {
      const row = [
        index + 1,
        dep?.dependencyType || 0,
      ];

      for (let i = 1; i <= 19; i++) {
        row.push(
          dep?.[`information_field${i}`] || 0
        );
      }

      dependencySheet.addRow(row);
    });



    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");

    link.href = URL.createObjectURL(blob);

    link.download = `Template-${panelName}.xlsx`;

    link.click();
  };

  return (
    <div>
   

      <button
        className="file-btn"
        style={{ marginRight: "30px" }}
        disabled={!selectedProject}
        onClick={handleExport}
      >
        Export .cfg file
      </button>

      <input
        ref={fileInputRef}
        type="file"
        accept=".xls,.xlsx"
        style={{ display: "none" }}
        onChange={handleExcelUpload}
      />

      <button
        className="file-btn"
        style={{ marginRight: "10px" }}
        disabled={!selectedProject}
        onClick={() => fileInputRef.current && fileInputRef.current.click()}
      >
        Upload excel
      </button>

      <button
        className="file-btn"
        disabled={!selectedProject}
        onClick={handleExcelExport}
      >
        Export excel template
      </button>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={alertType}
          variant="filled"
        >
          {alertMsg}
        </Alert>
      </Snackbar>
    </div>

  );
};

export default CloudProContentButton;